import { render, staticRenderFns } from "./photo_list.vue?vue&type=template&id=1afac876&scoped=true"
import script from "./photo_list.vue?vue&type=script&lang=js"
export * from "./photo_list.vue?vue&type=script&lang=js"
import style0 from "./photo_list.vue?vue&type=style&index=0&id=1afac876&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afac876",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1afac876')) {
      api.createRecord('1afac876', component.options)
    } else {
      api.reload('1afac876', component.options)
    }
    module.hot.accept("./photo_list.vue?vue&type=template&id=1afac876&scoped=true", function () {
      api.rerender('1afac876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/reports/big_meeting/form/photo_list.vue"
export default component.exports